export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/php-apache-service-stack-form';
